"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUIKey = void 0;
var _constants = require("./constants");
var getUIKey = exports.getUIKey = function getUIKey(basketID) {
  return "".concat(_constants.EDIT_FORM_UI, "_").concat(basketID);
};